import { Toasts } from '@fourthwall/components'
import type { ReplaceOrderItemsRequest } from '@fourthwall/services/dist/OrderApiClient'
import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

export const useItemsReplacementMutation = (orderId: string) => {
  const itemsReplacementMutation = useMutation({
    mutationFn: async (payload: ReplaceOrderItemsRequest) => {
      const { data } = await OrderApiClient.replaceOrderItems(orderId, payload)

      return data
    },
    onError: (error: ApiError) => {
      Toasts.notify(error.response?.data.title, { type: 'error' })
    },
  })

  return { itemsReplacementMutation }
}
